import React, { Component }  from 'react';
import Api                   from '../Utils/api';
import Utils                 from '../Utils/Utility';
import Parse                 from 'parse';
import UserNavbar            from './layout/user-navbar';
import SideBarMenu           from './dashboard/sidebar/sidebar-menu';
import NavigationMenu        from './dashboard/sidebar/navigation-menu';
import SideBarMenuItem       from './dashboard/sidebar/sidebar-menuitem';
import classNames            from 'classnames/bind';
import Analytics             from './visualization/analytics';
import Settings              from './dashboard/settings/settings';
import Billing               from './dashboard/billing/billing';
import AcctCreation          from './acct-creation';
import RegisterPaymentMethod from './register/RegisterPaymentMethod';
import Spinner               from "./generic/spinner";
import OrdersSummaryTable    from "./visualization/orders-summary-table";
import ChargeSummaryView    from "./custom-charges/charge-summary-view";
import {Link}                from "react-router";
import Stats2Table           from "./visualization/stats2-table";
import UserStats2Table       from "./visualization/userstats2-table";
import Stats                 from "./stats";
import Items                 from "../components/online-menu/items"
import LocationDetail        from "../components/location/location-detail"
import AllCharges            from "../components/custom-charges/all-charges"
import CustomChargeStore     from './stores/custom-charge-store';


export default class Dashboard  extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            activeLocationIndex     : 0,
            isActiveLocAccConnected : true,
            locationDetails         : [],
            showSpinner             : false,
            isBillingAccountTab     : false,
            isOrderSummaryView      : false,
            isOrdersView            : false,
            isChargeSummaryView     : false,
            isCustomersView         : false,
            isBillingView           : false,
            isSalesTrendView        : false,
            isPopularItemsView      : false,
            isOnlineMenuView        : false,
            isLocationDetailView    : true,
            isCustomChargesView     : false,
            headerLabel             : "Location Detail",
            showNavigationMenu      : false
        };

        this.enableOrderSummaryView  = this.enableOrderSummaryView .bind(this);
        this.enableChargeSummaryView  = this.enableChargeSummaryView .bind(this);
        this.enableOrdersView        = this.enableOrdersView.bind(this);
        this.enableCustomersView     = this.enableCustomersView.bind(this);
        this.enableBillingView       = this.enableBillingView.bind(this);
        this.enableSalesTrendView    = this.enableSalesTrendView.bind(this);
        this.enablePopularItemsView  = this.enablePopularItemsView.bind(this);
        this.enableOnlineMenuView    = this.enableOnlineMenuView.bind(this);
        this.enableLocationDetailView = this.enableLocationDetailView.bind(this);
        this.enableCustomChargesView = this.enableCustomChargesView.bind(this);
        this.changeLocation          = this.changeLocation.bind(this);
        this.generateSideBarMenuItem = this.generateSideBarMenuItem.bind(this);
        this.showSideBarMenu         = this.showSideBarMenu.bind(this);
        this.getActiveLocationObj    = this.getActiveLocationObj.bind(this);
        this.checkIfAccountConnected = this.checkIfAccountConnected.bind(this);
        this.navigationMenuAction    = this.navigationMenuAction.bind(this);
    }

    componentDidMount() {

        this.setState({showSpinner: true});

        let currentUser = Parse.User.current();
        let self = this;
        if (currentUser) {
            const businessDetail = currentUser.get("bizId");
            let locIds  = currentUser.get("locIds");
            const locPtr = currentUser.get("locationDetailPointer");
            const bizId = businessDetail.id;
            // const userId         = currentUser.id;
            // const sessionToken   = Parse.User.current().getSessionToken();
            const data = {};

            if (businessDetail) {
                Api.getBusinessDetail(bizId)
                    .then((res) => {
                        const businessDetail = res.data;
                        data.businessDetail = businessDetail;
                    }).then(() => {
                    return Api.getLocationsForBizId(bizId)
                }).then((response) => {
                    let locationDetails = response.data;

                    if (locIds != null){

                        //  return the matches array from the locIds array
                        locationDetails
                            = locationDetails.filter((fetchedLocation) => locIds.includes(fetchedLocation.objectId));

                        data.locationDetails = locationDetails;
                        return data;
                    }
                    else if (locPtr != null) {
                        locationDetails
                            = locationDetails.filter((fetchedLocation) => locPtr.id === fetchedLocation.objectId);

                        data.locationDetails = locationDetails;
                        return data;
                    }
                    else {
                        data.locationDetails = locationDetails;
                        return data;
                    }

                }).then((data) => {
                    // console.log(JSON.stringify(data));
                    const firstLocation = data.locationDetails[0];
                    let activeLocationTimeZone = firstLocation.timeZone ? firstLocation.timeZone : null;
                    localStorage.setItem("timeZone", activeLocationTimeZone);

                    return self.checkIfAccountConnected(firstLocation.objectId);
                }).then((isAccountConnected) => {
                    // console.log("location stripe connection:" + isAccountConnected);
                    data.isActiveLocAccConnected = isAccountConnected;
                    return data;
                }).then((data) => {
                    // console.log("Data:"+JSON.stringify(data));
                    self.setState({
                        ...data,
                        showSpinner: false,
                        showNavigationMenu:true,
                        isBillingAccountTab: true
                    });
                }).catch((error) => {
                    console.log("error" + JSON.stringify(error));
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    self.setState({showSpinner: false, showNavigationMenu:true});
                });
            }
        }
    }

    componentWillMount() {

        let currentUser = Parse.User.current();

        if (currentUser == null || currentUser.get("userType") != "Manager"){
            this.context.router.replace({
                pathname  : '/logout'
            });
        }

    }

    navigationMenuAction(){
        $('#sidebar, #content-sidebar').toggleClass('active-nav');
        $('.collapse.in').toggleClass('in');
        $('a[aria-expanded=true]').attr('aria-expanded', 'false');
    }

    checkIfAccountConnected(locationId) {

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();

        return Api.getLocationDetail(locationId, userId, sessionToken)
            .then(
                (result) => {
                    const locationDetail = result.data;

                    // Load the custom charges data
                    CustomChargeStore.onMainDataCustom(locationDetail);

                    if (locationDetail && locationDetail.privateData) {
                        const privateData = locationDetail.privateData;
                        if (privateData && privateData.stripeCredentials && privateData.stripeCredentials.stripe_user_id) {
                            return true

                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                },
                (error) => {
                    if (error != null && error.responseJSON != null && error.responseJSON.error != null) {
                        // console.log("Error occured while fetching latest user data!" + JSON.stringify(error));
                        alert(error.responseJSON.error.message);
                    }
                    return error;
                    // Utils.checkErrorIsInvalidSessionToken(error,this.context.router);
                    // this.setState({showSpinner : false });
                });
    }


    showSideBarMenu() {
        if (this.sbMenu) {
            this.sbMenu.openNav();
        }
    }

    changeLocation(locationIndex) {
        // console.log(`Change location index:${locationIndex}`);

        this.setState({showSpinner: true, isBillingAccountTab: false, showNavigationMenu:false});

        let self = this;
        Utils.isUserSessionInvalid().then((response) => {
            // user session in valid
            const locationToChange = self.state.locationDetails[locationIndex];
            const locId = locationToChange.objectId;

            let activeLocationTimeZone = locationToChange.timeZone ? locationToChange.timeZone : null;
            localStorage.setItem("timeZone", activeLocationTimeZone);

            this.checkIfAccountConnected(locId)
                .then((isAccountConnected) => {
                    // console.log("location stripe connection:" + isAccountConnected);
                    self.setState({
                        isActiveLocAccConnected: isAccountConnected,
                        activeLocationIndex: locationIndex,
                        showSpinner: false,
                        isBillingAccountTab: true,
                        showNavigationMenu:true
                    });
                }, (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    self.setState({showSpinner: false, showNavigationMenu:true});
                })

        }, (error) => {
            // console.log("error user session: "+JSON.stringify(error));
            // user session is invalid
            Utils.checkErrorIsInvalidSessionToken(error, self.context.router);

        });


    }

    generateSideBarMenuItem(bName) {
        const sideBarComponent
            = this.state.locationDetails.map((bLocation, idx) => {
            let activeIndex = 0;
            if (this.state.activeLocationIndex) {
                activeIndex = this.state.activeLocationIndex;
            }
            return (
                <SideBarMenuItem
                    isActiveIndex  = {activeIndex === idx}
                    key            = {`${bLocation.objectId}${idx}`}
                    locationIndex  = {idx}
                    locName        = {bLocation.name}
                    address        = {Utils.getAddressStrFromLocation(bLocation)}
                    changeLocation = {this.changeLocation}
                />
            );
        });

        return this.state.locationDetails.length > 1
            ? (
                <SideBarMenu
                    ref      = {(ref) => this.sbMenu = ref}
                    bName    = {bName}
                >
                    { sideBarComponent }
                </SideBarMenu>
            )
            : null;
    }

    getActiveLocationObj() {
        if (this.state.locationDetails.length < 1)
            return null;
        let activeIndex = 0;
        if (this.state.activeLocationIndex) {
            activeIndex = this.state.activeLocationIndex;
        }
        return this.state.locationDetails[activeIndex];
    }


    enableOrderSummaryView(){
        // close the side menu if app is running on mobile device
        if (Utils.isMobileDevice()){
            this.navigationMenuAction();
        }
        this.setState({
            isOrdersView            : false,
            isOrderSummaryView      : true,
            isCustomersView         : false,
            isBillingView           : false,
            isSalesTrendView        : false,
            isPopularItemsView      : false,
            isOnlineMenuView        : false,
            isLocationDetailView    : false,
            isCustomChargesView     : false,
            isChargeSummaryView     : false,
            headerLabel : "Order Summary"

        });
    }

    enableOrdersView(){
        // close the side menu if app is running on mobile device
        if (Utils.isMobileDevice()){
            this.navigationMenuAction();
        }
        this.setState({
            isOrdersView            : true,
            isOrderSummaryView      : false,
            isCustomersView         : false,
            isBillingView           : false,
            isSalesTrendView        : false,
            isPopularItemsView      : false,
            isOnlineMenuView        : false,
            isLocationDetailView    : false,
            isCustomChargesView    : false,
            isChargeSummaryView    : false,
            headerLabel : "Orders"
        });
    }



    enableCustomersView(){
        // close the side menu if app is running on mobile device
        if (Utils.isMobileDevice()){
            this.navigationMenuAction();
        }
        this.setState({
            isOrdersView            : false,
            isOrderSummaryView      : false,
            isCustomersView         : true,
            isBillingView           : false,
            isSalesTrendView        : false,
            isPopularItemsView      : false,
            isOnlineMenuView        : false,
            isLocationDetailView    : false,
            isCustomChargesView     : false,
            isChargeSummaryView     : false,
            headerLabel : "Customers"

        });
    }

    enableBillingView(){
        // close the side menu if app is running on mobile device
        if (Utils.isMobileDevice()){
            this.navigationMenuAction();
        }
        this.setState({
            isOrdersView            : false,
            isOrderSummaryView      : false,
            isCustomersView         : false,
            isBillingView           : true,
            isSalesTrendView        : false,
            isPopularItemsView      : false,
            isOnlineMenuView        : false,
            isLocationDetailView    : false,
            isCustomChargesView     : false,
            isChargeSummaryView     : false,
            headerLabel              : "Billing"

        });
    }
    enableOnlineMenuView(){
        // close the side menu if app is running on mobile device
        if (Utils.isMobileDevice()){
            this.navigationMenuAction();
        }
        this.setState({
            isOrdersView            : false,
            isOrderSummaryView      : false,
            isCustomersView         : false,
            isBillingView           : false,
            isSalesTrendView        : false,
            isPopularItemsView      : false,
            isOnlineMenuView        : true,
            isLocationDetailView    : false,
            isCustomChargesView     : false,
            isChargeSummaryView     : false,
            headerLabel              : "Online Menu (Beta)"

        });
    }

    enableLocationDetailView(){

        // close the side menu if app is running on mobile device
        if (Utils.isMobileDevice()){
            this.navigationMenuAction();
        }

        this.setState({
            isOrdersView            : false,
            isOrderSummaryView      : false,
            isCustomersView         : false,
            isBillingView           : false,
            isSalesTrendView        : false,
            isPopularItemsView      : false,
            isOnlineMenuView        : false,
            isLocationDetailView    : true,
            isCustomChargesView     : false,
            isChargeSummaryView     : false,
            headerLabel              : "Location Detail"

        });
    }



    enableCustomChargesView(){
        // close the side menu if app is running on mobile device
        if (Utils.isMobileDevice()){
            this.navigationMenuAction();
        }

        this.setState({
            isOrdersView            : false,
            isOrderSummaryView      : false,
            isCustomersView         : false,
            isBillingView           : false,
            isSalesTrendView        : false,
            isPopularItemsView      : false,
            isOnlineMenuView        : false,
            isLocationDetailView    : false,
            isCustomChargesView     : true,
            isChargeSummaryView     : false,
            headerLabel              : "Custom Charges (Beta)"

        });
    }

    enableChargeSummaryView(){
        // close the side menu if app is running on mobile device
        if (Utils.isMobileDevice()){
            this.navigationMenuAction();
        }

        this.setState({
            isOrdersView            : false,
            isOrderSummaryView      : false,
            isCustomersView         : false,
            isBillingView           : false,
            isSalesTrendView        : false,
            isPopularItemsView      : false,
            isOnlineMenuView        : false,
            isLocationDetailView    : false,
            isCustomChargesView     : false,
            isChargeSummaryView     : true,
            headerLabel : "Charge Summary (Beta)"

        });
    }

    enableSalesTrendView(){
        // close the side menu if app is running on mobile device
        if (Utils.isMobileDevice()){
            this.navigationMenuAction();
        }
        this.setState({
            isOrdersView            : false,
            isOrderSummaryView      : false,
            isCustomersView         : false,
            isBillingView           : false,
            isSalesTrendView        : true,
            isPopularItemsView      : false,
            isOnlineMenuView        : false,
            isLocationDetailView    : false,
            isCustomChargesView     : false,
            isChargeSummaryView     : false,
            headerLabel             : "Sales Trend"

        });
    }

    enablePopularItemsView(){
        // close the side menu if app is running on mobile device
        if (Utils.isMobileDevice()){
            this.navigationMenuAction();
        }
        this.setState({
            isOrdersView            : false,
            isOrderSummaryView      : false,
            isCustomersView         : false,
            isBillingView           : false,
            isSalesTrendView        : false,
            isPopularItemsView      : true,
            isOnlineMenuView        : false,
            isLocationDetailView    : false,
            isCustomChargesView     : false,
            isChargeSummaryView     : false,
            headerLabel             : "Popular Items"

        });
    }

    render() {
        let businessName     = "";
        let bizId     = "";
        const businessDetail = this.state.businessDetail;
        const activeLocation = this.getActiveLocationObj();

        if (businessDetail) {
            businessName     = businessDetail.name;
            bizId            = businessDetail.objectId;
        }

        let locationName     = "";
        let locationAddress = Utils.getAddressStrFromLocation( activeLocation );

        // Check the active location object
        if(activeLocation){
            // get the location name
            locationName = activeLocation.name
        }

        var showChangeLocationButton = false;
        if (this.state.locationDetails.length > 1) {
            showChangeLocationButton = true
        }

        // Enable Online Ordering

        let enableOnlineMenu = true; // default we can set false, still true for testing
        let enableCustomCharges = true;
        // if(!Utils.isEmptyObj(activeLocation) && !Utils.isEmptyObj(activeLocation.locationConfig)){
        //
        //     let locConfig = activeLocation.locationConfig;
        //
        //     // Disable this functionality
        //     // if (locConfig.enableOnlineMenuOnMD){
        //     //     enableOnlineMenu = locConfig.enableOnlineMenuOnMD
        //     // }
        //
        //     // if (locConfig.enableCustomChargesOnMD){
        //     //     enableCustomCharges = locConfig.enableCustomChargesOnMD
        //     // }
        //
        //     enableOnlineMenu = true;
        //     enableCustomCharges = true;
        // }

        return (
            <div className="wrapper">
                { this.state.showSpinner ? <Spinner/> : null }
                {
                    this.generateSideBarMenuItem(businessName)
                }
                {
                    this.state.showNavigationMenu ? (
                        <div>
                            <nav id="sidebar" className={"sidebar-nav"}>
                                <div className="sidebar-header">
                                    {/*<h3>{locationName}</h3>*/}
                                    <div className="location-heading">{locationName}</div>
                                    <p className="list-group-item-text rst-address" >{locationAddress}</p>
                                    {
                                        showChangeLocationButton ? (
                                            <a
                                                href      = "JavaScript:void(0);"
                                                className = "btn btn-link btn-danger"
                                                role      = "button"
                                                onClick   = {this.showSideBarMenu}
                                                className="download">Switch Location</a>
                                        ) : null
                                    }
                                </div>

                                <ul className="list-unstyled components">
                                    <li className={this.state.isLocationDetailView ? "active-menu" : null}>
                                        <a
                                            href= "JavaScript:void(0);"
                                            onClick = {this.enableLocationDetailView}
                                        ><i className="fa fa-fw fa-pencil-square-o"/>Location Detail</a>
                                    </li>
                                    <li className={this.state.isOrderSummaryView ? "active-menu mt-5" : "mt-5"}>
                                        <a
                                            href= "JavaScript:void(0);"
                                            onClick = {this.enableOrderSummaryView}
                                        ><i className="fa fa-fw fa-home"/>Order Summary</a>
                                        {/*<Link to="/dashboard"><i className="fa fa-fw fa-home"/>Dashboard</Link>*/}
                                    </li>
                                    <li className={this.state.isOrdersView ? "active-menu mt-5" : "mt-5"}>
                                        <a
                                            href= "JavaScript:void(0);"
                                            onClick = {this.enableOrdersView}
                                        ><i className="fa fa-fw fa-table"/>Orders</a>
                                    </li>
                                    <li className={this.state.isCustomersView ? "active-menu mt-5" : "mt-5"}>
                                        <a
                                            href= "JavaScript:void(0);"
                                            onClick = {this.enableCustomersView}
                                        ><i className="fa fa-fw fa-users"/>Customers</a>
                                    </li>
                                    <li className="mt-5">
                                        <a href="#analyticsMenu" data-toggle="collapse"
                                           aria-expanded="false"><i className="fa fa-fw fa-bar-chart"/>Analytics</a>
                                        <ul className="collapse list-unstyled" id="analyticsMenu">
                                            <li className={this.state.isSalesTrendView ? "active-menu mt-5" : "mt-5"}><a
                                                href= "JavaScript:void(0);"
                                                onClick = {this.enableSalesTrendView}
                                            >Sales Trend</a></li>
                                            <li className={this.state.isPopularItemsView ? "active-menu mt-5" : "mt-5"}><a
                                                href= "JavaScript:void(0);"
                                                onClick = {this.enablePopularItemsView}
                                            >Popular Items</a></li>
                                        </ul>
                                    </li>

                                    <li className={this.state.isBillingView ? "active-menu mt-5" : "mt-5"}>
                                        <a
                                            href= "JavaScript:void(0);"
                                            onClick = {this.enableBillingView}
                                        ><i className="fa fa-fw fa-clipboard"/>Billing</a>
                                    </li>
                                    {
                                        enableOnlineMenu ? (
                                            <li className={this.state.isOnlineMenuView ? "active-menu mt-5" : "mt-5"}>
                                                <a
                                                    href= "JavaScript:void(0);"
                                                    onClick = {this.enableOnlineMenuView}
                                                ><i className="fa fa-fw fa-clipboard"/>Online Menu</a>
                                            </li>
                                        ) : null

                                    }

                                    {/*// CustomChargeStore.isCustomChargeConfigured() ? (*/}
                                    {
                                        enableCustomCharges ? (
                                            <li className={this.state.isCustomChargesView ? "active-menu mt-5" : "mt-5"}>
                                                <a
                                                    href= "JavaScript:void(0);"
                                                    onClick = {this.enableCustomChargesView}
                                                ><i className="fa fa-fw fa-clipboard"/>Custom Charges</a>
                                            </li>

                                        ) : null

                                    }
                                    {
                                        enableCustomCharges ? (
                                            <li className={this.state.isChargeSummaryView ? "active-menu mt-5" : "mt-5"}>
                                                <a
                                                    href= "JavaScript:void(0);"
                                                    onClick = {this.enableChargeSummaryView}
                                                ><i className="fa fa-fw fa-table"/>Charge Summary</a>
                                            </li>
                                        ) : null

                                    }
                                    <li className="mt-5">
                                        {/*<a href="/logout" ><i className="fa fa-fw fa-sign-out"/>Logout</a>*/}
                                        <Link to="/logout"><i className="fa fa-fw fa-sign-out"/>Logout</Link>
                                    </li>
                                </ul>
                            </nav>
                            <div id="content-sidebar">
                                <nav className="navbar navbar-default">
                                    <div className="container-fluid1">

                                        <div className="navbar-header">
                                            <button type="button" id="sidebarCollapse"
                                                    className="btn navbar-btn" onClick={this.navigationMenuAction}>
                                                <i className="glyphicon glyphicon-align-left"></i>
                                                <span></span>
                                            </button>
                                        </div>
                                        <span className="title-heading">{this.state.headerLabel}</span>
                                        {/*{*/}
                                        {/*this.state.isOnlineMenuView ? ( <span className="sub-title-heading">This screen is work in progress*/}
                                        {/*</span>) : null*/}
                                        {/*}*/}
                                        <div className="user-detail">
                                            <p className={"user-name"}> {Parse.User.current().get('name')}</p>
                                            {/*<a*/}
                                            {/*href      = "JavaScript:void(0);"*/}
                                            {/*className = "btn-logout"*/}
                                            {/*onClick   = {this.logoutUser}*/}
                                            {/*>Logout</a>*/}
                                            <Link  className = "btn-logout" to="/logout">Logout</Link>
                                        </div>

                                    </div>
                                </nav>

                                <div className="header-line"></div>
                                <div >
                                    {
                                        this.state.isOrderSummaryView && this.state.isActiveLocAccConnected ? (
                                            <OrdersSummaryTable
                                                activeLocation = {activeLocation}
                                            />
                                        ) : null
                                    }
                                    {
                                        this.state.isOrdersView && this.state.isActiveLocAccConnected ? (
                                            <Stats2Table
                                                activeLocation = {activeLocation}
                                            />
                                        ) : null
                                    }
                                    {
                                        this.state.isCustomersView && this.state.isActiveLocAccConnected ? (
                                            <UserStats2Table
                                                activeLocation = {activeLocation}
                                            />
                                        ) : null
                                    }
                                    {
                                        this.state.isBillingView && this.state.isActiveLocAccConnected ? (
                                            <Billing activeLocation={activeLocation}
                                                     bizId={bizId}
                                                     isActive={true}/>
                                        ) : null
                                    }
                                    {
                                        this.state.isSalesTrendView && this.state.isActiveLocAccConnected ? (
                                            <Stats
                                                activeLocation = {activeLocation}
                                            />
                                        ) : null
                                    }
                                    {
                                        this.state.isPopularItemsView && this.state.isActiveLocAccConnected ? (
                                            <div>

                                                <h3>Coming Soon...</h3>

                                            </div>
                                        ) : null
                                    }
                                    {
                                        this.state.isOnlineMenuView ? (
                                            <Items activeLocation={activeLocation}
                                                   bizId={bizId}
                                                   isActive={true}/>
                                        ) : null
                                    }
                                    {
                                        this.state.isLocationDetailView && this.state.isActiveLocAccConnected ? (
                                            <LocationDetail activeLocation={activeLocation}
                                                            bizId={bizId}
                                                            isActive={true}/>
                                        ) : null
                                    }
                                    {
                                        this.state.isCustomChargesView && this.state.isActiveLocAccConnected ? (
                                            <AllCharges activeLocation={activeLocation}
                                                        bizId={bizId}
                                                        isActive={true}/>
                                        ) : null
                                    }
                                    {
                                        this.state.isChargeSummaryView && this.state.isActiveLocAccConnected ? (
                                            <ChargeSummaryView
                                                activeLocation = {activeLocation}
                                            />
                                        ) : null
                                    }
                                    {
                                        !this.state.isActiveLocAccConnected && !this.state.isOnlineMenuView ? (
                                            <RegisterPaymentMethod activeLocation={activeLocation}/>
                                        ) : null
                                    }

                                </div>
                            </div>
                        </div>
                    ) : null
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// src/components/dashboard.js